document.addEventListener("DOMContentLoaded", function () {
  let globalPriceSliderMasterRange = null;

  function ensureMasterRangeInitialized(sliderElement) {
    if (globalPriceSliderMasterRange) {
      return globalPriceSliderMasterRange;
    }

    let min = 0;
    let max = 10000;

    if (sliderElement) {
      const minDataset = sliderElement.dataset.min;
      const maxDataset = sliderElement.dataset.max;

      if (minDataset !== undefined) {
        min = parseFloat(minDataset || "0");
      }
      if (maxDataset !== undefined) {
        max =
          maxDataset && maxDataset !== "Infinity"
            ? parseFloat(maxDataset)
            : max;
      }
    }

    const isMobile =
      sliderElement && sliderElement.closest("#Facet-Drawer") !== null;

    if (isMobile) {
      const mobileMaxInput = document.getElementById("price-max-mobile");
      const mobileGteInput = document.getElementById("price-gte-mobile");
      const mobileLteInput = document.getElementById("price-lte-mobile");

      if (mobileMaxInput && mobileMaxInput.placeholder) {
        const placeholderMax = parseFloat(mobileMaxInput.placeholder);
        if (!isNaN(placeholderMax) && placeholderMax > max) {
          max = placeholderMax;
        }
      }

      if (sliderElement.dataset.rangeMax) {
        const rangeMax = parseFloat(sliderElement.dataset.rangeMax);
        if (!isNaN(rangeMax) && rangeMax > 0) {
          max = rangeMax;
        }
      }

      if (sliderElement.dataset.rangeMin) {
        const rangeMin = parseFloat(sliderElement.dataset.rangeMin);
        if (!isNaN(rangeMin) && rangeMin >= 0) {
          min = rangeMin;
        }
      }

      if (sliderElement.dataset.maxValue) {
        const altMax = parseFloat(sliderElement.dataset.maxValue);
        if (!isNaN(altMax) && altMax > 0) {
          max = altMax;
        }
      }

      if (sliderElement.dataset.minValue) {
        const altMin = parseFloat(sliderElement.dataset.minValue);
        if (!isNaN(altMin) && altMin >= 0) {
          min = altMin;
        }
      }
    }

    if (max <= min || max === 10000) {
      const desktopSlider = document.querySelector(
        "custom-price-slider:not(#Facet-Drawer custom-price-slider) .price_slider"
      );
      if (desktopSlider) {
        const desktopMin = parseFloat(desktopSlider.dataset.min || "0");
        const desktopMax = parseFloat(desktopSlider.dataset.max || "10000");

        if (desktopMax > desktopMin) {
          min = desktopMin;
          max = desktopMax;
        }
      }
    }

    min = Math.round(min);
    max = Math.round(max);

    if (min > max) {
      globalPriceSliderMasterRange = { min: 0, max: 10000 };
    } else if (min === max) {
      globalPriceSliderMasterRange = { min: 0, max: Math.max(max, 10000) };
    } else {
      globalPriceSliderMasterRange = { min: min, max: max };
    }

    return globalPriceSliderMasterRange;
  }

  function ensureUnifiedSliderStyles() {
    const existingStyles = document.querySelectorAll(
      "#nouislider-unified-styles, #nouislider-custom-styles"
    );
    existingStyles.forEach((style) => style.remove());

    const sliderElements = document.querySelectorAll(
      ".noUi-target, .noUi-handle, .noUi-connect"
    );
    sliderElements.forEach((element) => {
      element.removeAttribute("style");
    });
  }

  class CustomPriceSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = null;
      this.minInputDisplay = null;
      this.maxInputDisplay = null;
      this.hiddenGte = null;
      this.hiddenLte = null;
      this.noUiSliderInstance = null;
      this.isResetting = false;
      this._isSliderFullyInitialized = false;
    }

    connectedCallback() {
      ensureUnifiedSliderStyles();
      requestAnimationFrame(() => {
        this._initializeSlider();
      });
    }

    resetSlider() {
      this.isResetting = true;

      if (!this._ensureSliderInitialized()) {
        if (window.noUiSliderLoading) {
          window.noUiSliderLoading.then(() => {
            setTimeout(() => {
              if (this._ensureSliderInitialized()) {
                this._performReset();
              } else {
                this.isResetting = false;
              }
            }, 100);
          });
          return;
        }
        this.isResetting = false;
        return;
      }

      this._performReset();
    }

    _performReset() {
      try {
        if (!this.noUiSliderInstance) return;

        const rangeMin = this.noUiSliderInstance.options.range.min;
        const rangeMax = this.noUiSliderInstance.options.range.max;
        this.noUiSliderInstance.set([rangeMin, rangeMax]);

        if (this.hiddenGte) this.hiddenGte.value = rangeMin;
        if (this.hiddenLte) this.hiddenLte.value = rangeMax;
      } catch (error) {
        console.error("[PRICE-RESET] Error al resetear:", error);
      } finally {
        this.isResetting = false;
      }
    }

    _initializeSlider() {
      if (this._isSliderFullyInitialized) return true;

      if (!this._queryDomElements()) {
        return false;
      }

      ensureMasterRangeInitialized(this.sliderElement);

      const sliderConfig = this._getNoUiSliderConfig();
      if (!sliderConfig) {
        return false;
      }

      this._destroyExistingSliderInstance();

      const createResult = this._createNoUiSlider(sliderConfig);

      if (createResult && typeof createResult.then === "function") {
        createResult.then((success) => {
          if (success) {
            this._attachSliderEventListeners();
            this._attachInputDisplayListeners();
            this._isSliderFullyInitialized = true;
          }
        });
        return false;
      }

      if (!createResult) {
        return false;
      }

      this._attachSliderEventListeners();
      this._attachInputDisplayListeners();

      this._isSliderFullyInitialized = true;
      return true;
    }

    _ensureSliderInitialized() {
      if (this.noUiSliderInstance && this._isSliderFullyInitialized) {
        return true;
      }
      return this._initializeSlider();
    }

    _queryDomElements() {
      this.sliderElement = this.querySelector(".price_slider");

      const isMobile = this.closest("#Facet-Drawer") !== null;
      const suffix = isMobile ? "-mobile" : "";

      this.hiddenGte = document.getElementById(`price-gte${suffix}`);
      this.hiddenLte = document.getElementById(`price-lte${suffix}`);
      this.minInputDisplay = document.getElementById(`price-min${suffix}`);
      this.maxInputDisplay = document.getElementById(`price-max${suffix}`);

      const missingElements = [];
      if (!this.sliderElement) missingElements.push(".price_slider");
      if (!this.hiddenGte) missingElements.push(`#price-gte${suffix}`);
      if (!this.hiddenLte) missingElements.push(`#price-lte${suffix}`);
      if (!this.minInputDisplay) missingElements.push(`#price-min${suffix}`);
      if (!this.maxInputDisplay) missingElements.push(`#price-max${suffix}`);

      if (missingElements.length > 0) {
        return false;
      }

      return true;
    }

    _getNoUiSliderConfig() {
      if (!globalPriceSliderMasterRange) {
        ensureMasterRangeInitialized(this.sliderElement);
        if (!globalPriceSliderMasterRange) {
          return null;
        }
      }
      if (!this.sliderElement || !this.hiddenGte || !this.hiddenLte)
        return null;

      const masterRange = globalPriceSliderMasterRange;
      const isMobile = this.closest("#Facet-Drawer") !== null;

      let initialMinVal = masterRange.min;
      let initialMaxVal = masterRange.max;

      if (this.hiddenGte.value && this.hiddenGte.value.trim() !== "") {
        const parsedMin = parseFloat(this.hiddenGte.value);
        if (!isNaN(parsedMin)) {
          initialMinVal = parsedMin;
        }
      }

      if (this.hiddenLte.value && this.hiddenLte.value.trim() !== "") {
        const parsedMax = parseFloat(this.hiddenLte.value);
        if (!isNaN(parsedMax)) {
          initialMaxVal = parsedMax;
        }
      }

      if (initialMinVal === 0 && initialMaxVal === 0) {
        initialMinVal = masterRange.min;
        initialMaxVal = masterRange.max;
      }

      initialMinVal = Math.max(
        masterRange.min,
        Math.min(initialMinVal, masterRange.max)
      );
      initialMaxVal = Math.min(
        masterRange.max,
        Math.max(initialMaxVal, masterRange.min)
      );

      if (initialMinVal > initialMaxVal) {
        initialMaxVal = initialMinVal;
      }

      const config = {
        start: [Math.round(initialMinVal), Math.round(initialMaxVal)],
        connect: true,
        step: 1,
        direction: document.dir || "ltr",
        range: { min: masterRange.min, max: masterRange.max },
        format: {
          to: (value) => Math.round(value),
          from: (value) => Number(value),
        },
      };

      return config;
    }

    _destroyExistingSliderInstance() {
      if (this.sliderElement && this.sliderElement.noUiSlider) {
        try {
          this.sliderElement.noUiSlider.destroy();
        } catch (destroyError) {}
        this.noUiSliderInstance = null;
      }
    }

    _createNoUiSlider(config) {
      if (!this.sliderElement) return false;

      if (typeof noUiSlider === "undefined") {
        return this._loadNoUiSliderAndCreate(config);
      }

      try {
        noUiSlider.create(this.sliderElement, config);
        this.noUiSliderInstance = this.sliderElement.noUiSlider;
        return !!this.noUiSliderInstance;
      } catch (e) {
        return false;
      }
    }

    _loadNoUiSliderAndCreate(config) {
      return new Promise((resolve) => {
        if (window.noUiSliderLoading) {
          window.noUiSliderLoading.then(() => {
            if (typeof noUiSlider !== "undefined") {
              resolve(this._createNoUiSliderSync(config));
            } else {
              resolve(false);
            }
          });
          return;
        }

        window.noUiSliderLoading = new Promise((resolveLoad) => {
          const cssLink = document.createElement("link");
          cssLink.rel = "stylesheet";
          cssLink.href =
            "https://cdn.jsdelivr.net/npm/nouislider@15.7.1/dist/nouislider.min.css";
          document.head.appendChild(cssLink);

          const script = document.createElement("script");
          script.src =
            "https://cdn.jsdelivr.net/npm/nouislider@15.7.1/dist/nouislider.min.js";
          script.onload = () => {
            resolveLoad();
          };
          script.onerror = () => {
            resolveLoad();
          };
          document.head.appendChild(script);
        });

        window.noUiSliderLoading.then(() => {
          if (typeof noUiSlider !== "undefined") {
            resolve(this._createNoUiSliderSync(config));
          } else {
            resolve(false);
          }
        });
      });
    }

    _createNoUiSliderSync(config) {
      try {
        noUiSlider.create(this.sliderElement, config);
        this.noUiSliderInstance = this.sliderElement.noUiSlider;
        return !!this.noUiSliderInstance;
      } catch (e) {
        return false;
      }
    }

    _attachSliderEventListeners() {
      if (!this.noUiSliderInstance) return;

      this.noUiSliderInstance.on(
        "update",
        (values, handle, unencoded, tap, positions, noUiSlider) => {
          const [minVal, maxVal] = noUiSlider
            .get()
            .map((v) => Math.round(Number(v)));
          this._updateDisplayValues(minVal, maxVal);
          this._updateHiddenInputValues(minVal, maxVal);

          const event = new CustomEvent("price-updated", {
            detail: { min: minVal, max: maxVal },
            bubbles: true,
            cancelable: true,
          });
          this.dispatchEvent(event);
        }
      );
    }

    _updateDisplayValues(minVal, maxVal) {
      if (
        this.minInputDisplay &&
        document.activeElement !== this.minInputDisplay
      ) {
        this.minInputDisplay.value = minVal;
      }
      if (
        this.maxInputDisplay &&
        document.activeElement !== this.maxInputDisplay
      ) {
        this.maxInputDisplay.value = maxVal;
      }
    }

    _updateHiddenInputValues(minVal, maxVal) {
      if (this.hiddenGte) this.hiddenGte.value = minVal;
      if (this.hiddenLte) this.hiddenLte.value = maxVal;
    }

    _attachInputDisplayListeners() {
      this._setupInputListenerFor(this.minInputDisplay, 0);
      this._setupInputListenerFor(this.maxInputDisplay, 1);
    }

    _setupInputListenerFor(inputElement, handleIndex) {
      if (!inputElement) return;

      let debounceTimeout;

      inputElement.addEventListener("input", () => {
        if (!this.noUiSliderInstance || !this._isSliderFullyInitialized) {
          return;
        }

        clearTimeout(debounceTimeout);

        debounceTimeout = setTimeout(() => {
          const inputValue = inputElement.value;
          const { min: rangeMin, max: rangeMax } =
            this.noUiSliderInstance.options.range;
          let valueToSet;

          if (inputValue === "") {
            return;
          }

          let numValue = Number(inputValue);
          if (isNaN(numValue)) {
            return;
          }

          numValue = Math.round(numValue);
          valueToSet = Math.max(rangeMin, Math.min(rangeMax, numValue));
          valueToSet = Math.max(rangeMin, Math.min(rangeMax, numValue));

          if (handleIndex === 0) {
            this.noUiSliderInstance.set([valueToSet, null], false);
          } else {
            this.noUiSliderInstance.set([null, valueToSet], false);
          }
        }, 500);
      });

      inputElement.addEventListener("blur", () => {
        clearTimeout(debounceTimeout);

        if (!this.noUiSliderInstance || !this._isSliderFullyInitialized) {
          return;
        }

        const inputValue = inputElement.value;
        const { min: rangeMin, max: rangeMax } =
          this.noUiSliderInstance.options.range;
        const currentSliderValues = this.noUiSliderInstance
          .get()
          .map((v) => Number(v));
        let finalValue;

        if (inputValue === "") {
          finalValue = currentSliderValues[handleIndex];
        } else {
          let numValue = Number(inputValue);
          if (isNaN(numValue)) {
            finalValue = currentSliderValues[handleIndex];
          } else {
            finalValue = Math.round(numValue);
          }
        }

        finalValue = Math.max(rangeMin, Math.min(rangeMax, finalValue));

        if (handleIndex === 0) {
          finalValue = Math.min(finalValue, currentSliderValues[1]);
        } else {
          finalValue = Math.max(finalValue, currentSliderValues[0]);
        }

        if (handleIndex === 0) {
          this.noUiSliderInstance.set([finalValue, null], true);
        } else {
          this.noUiSliderInstance.set([null, finalValue], true);
        }
      });

      inputElement.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.keyCode === 13) {
          event.preventDefault();
          clearTimeout(debounceTimeout);
          event.target.blur();
        }
      });
    }

    clearResettingFlag() {
      this.isResetting = false;
    }
  }

  if (
    typeof customElements !== "undefined" &&
    !customElements.get("custom-price-slider")
  ) {
    customElements.define("custom-price-slider", CustomPriceSlider);
  }

  class FilterUpdater {
    constructor(formSelector = "#CollectionFiltersForm") {
      this.formSelector = formSelector;
      this.productGrid = document.getElementById("product-grid");
      this.productGridContainer = document.getElementById(
        "ProductGridContainer"
      );
      this.searchInput = document.getElementById("search-input");
      this._isUpdating = false;
    }

    async apply(isFilterChange = true) {
      if (this._isUpdating) {
        return;
      }

      const currentParams = new URLSearchParams(window.location.search);

      if (currentParams.has("page") && !isFilterChange) {
        return;
      }

      if (isFilterChange && currentParams.has("page")) {
        currentParams.delete("page");
        const newUrl = currentParams.toString() 
          ? `${window.location.pathname}?${currentParams.toString()}`
          : window.location.pathname;
        history.replaceState(null, "", newUrl);
      }

      this._isUpdating = true;

      try {
        const form = document.querySelector(this.formSelector);
        if (!form) {
          return;
        }

        const formData = new FormData(form);

        const searchParams = this._buildSearchParams(formData, isFilterChange);
        const paramsString = searchParams.toString();

        try {
          const newUrl = paramsString
            ? `${window.location.pathname}?${paramsString}`
            : window.location.pathname;

          history.pushState({ searchParams: paramsString }, "", newUrl);

          this._syncAllFilterDisplays(searchParams);

          await this.fetchFilteredResults(paramsString);

          document.dispatchEvent(
            new CustomEvent("filtersUpdated", {
              detail: {
                searchParams: paramsString,
                params: Object.fromEntries(searchParams.entries()),
              },
            })
          );
        } catch (error) {
          this._hideLoadingState();
        }
      } finally {
        this._isUpdating = false;
      }
    }

    _syncAllFilterDisplays(searchParams) {
      if (
        typeof window.FilterUIManager !== "undefined" &&
        window.FilterUIManager.updateAllDisplays
      ) {
        try {
          window.FilterUIManager.updateAllDisplays(searchParams);
        } catch (error) {}
      }
    }

    _buildSearchParams(formData, resetPage = true) {
      const currentParams = new URLSearchParams(window.location.search);

      const allParams = {};

      const hasFilterChanges = this._detectFilterChanges(formData, currentParams);
      
      if (hasFilterChanges) {
        resetPage = true;
      }

      for (const [key, value] of currentParams.entries()) {
        if (key === "page" && !resetPage) {
          allParams[key] = value;
        } else if (key !== "page") {
          if (key === "filter.p.tag") {
            if (!allParams[key]) {
              allParams[key] = [];
            }
            allParams[key].push(value);
          } else if (
            key.startsWith("filter.") &&
            !key.includes("price") &&
            !key.includes("delivery") &&
            !key.includes("certified") &&
            !key.includes("filter.p.tag")
          ) {
            if (!allParams[key]) {
              allParams[key] = [];
            }
            allParams[key].push(value);
          } else {
            allParams[key] = value;
          }
        }
      }

      const updatedParams = new Set();

      const updateParam = (key, value, append = false) => {
        if (
          value !== undefined &&
          value !== null &&
          (value !== "" || value === "0")
        ) {
          updatedParams.add(key);
          if (append) {
            if (!allParams[key]) {
              allParams[key] = [];
            }
            if (Array.isArray(allParams[key])) {
              allParams[key].push(value);
            }
          } else {
            allParams[key] = value;
          }
        }
      };

      const existingSearchParam = currentParams.get("q");
      if (existingSearchParam && existingSearchParam.trim() !== "") {
        updateParam("q", existingSearchParam.trim());
      } else {
        delete allParams["q"];
        updatedParams.add("q");
      }

      let finalPriceGte = "";
      let finalPriceLte = "";

      const isMobileActive = document
        .querySelector("#Facet-Drawer")
        ?.classList.contains("active");

      if (isMobileActive) {
        const mobileMinInput = document.getElementById("price-min-mobile");
        const mobileMaxInput = document.getElementById("price-max-mobile");

        if (mobileMinInput && mobileMinInput.value !== undefined) {
          const minValue = parseFloat(mobileMinInput.value);
          if (!isNaN(minValue) && minValue >= 0) {
            finalPriceGte = minValue.toString();
          } else if (mobileMinInput.value.trim() === "0") {
            finalPriceGte = "0";
          }
        }

        if (mobileMaxInput && mobileMaxInput.value !== undefined) {
          const maxValue = parseFloat(mobileMaxInput.value);
          if (!isNaN(maxValue) && maxValue >= 0) {
            finalPriceLte = maxValue.toString();
          }
        }
      } else {
        const priceGte = formData.get("filter.v.price.gte");
        if (priceGte && priceGte.trim() !== "") {
          finalPriceGte = priceGte;
        }

        const priceLte = formData.get("filter.v.price.lte");
        if (priceLte && priceLte.trim() !== "") {
          finalPriceLte = priceLte;
        }
      }

      if (
        (finalPriceGte !== undefined &&
          finalPriceGte !== null &&
          finalPriceGte !== "") ||
        finalPriceGte === "0"
      ) {
        updateParam("filter.v.price.gte", finalPriceGte);
      }

      if (
        finalPriceLte !== undefined &&
        finalPriceLte !== null &&
        finalPriceLte !== ""
      ) {
        updateParam("filter.v.price.lte", finalPriceLte);
      }

      const deliverySpeedKey = "filter.p.m.wk_custom_field.cus_delivery_speed";
      const deliverySpeed = formData.get(deliverySpeedKey);

      const mobileDeliveryCheckbox = document.querySelector(
        '#Facet-Drawer input[name="filter.p.m.wk_custom_field.cus_delivery_speed"]:checked'
      );

      const finalDeliverySpeed =
        deliverySpeed ||
        (mobileDeliveryCheckbox ? mobileDeliveryCheckbox.value : "");

      if (finalDeliverySpeed && finalDeliverySpeed !== "") {
        updateParam(deliverySpeedKey, finalDeliverySpeed);
        updateParam("delivery", finalDeliverySpeed);
      } else {
        delete allParams[deliverySpeedKey];
        delete allParams["delivery"];
        updatedParams.add(deliverySpeedKey);
        updatedParams.add("delivery");
      }

      const videoCertifiedToggle = document.getElementById(
        "video-certified-toggle"
      );
      if (videoCertifiedToggle && videoCertifiedToggle.checked) {
        updateParam("filter.p.m.custom.certified", "View all");
      } else {
        delete allParams["filter.p.m.custom.certified"];
        updatedParams.add("filter.p.m.custom.certified");
      }

      const activeTagButtons = document.querySelectorAll(
        ".collection-tags__tag.collection-tags__tag--active"
      );

      const mobileTagCheckboxes = document.querySelectorAll(
        '#Facet-Drawer input[name="filter.p.tag"]:checked'
      );

      delete allParams["filter.p.tag"];
      updatedParams.add("filter.p.tag");

      if (activeTagButtons.length > 0) {
        activeTagButtons.forEach((button) => {
          const tagContent = button.textContent?.trim();
          if (tagContent) {
            updateParam("filter.p.tag", tagContent, true);
          }
        });
      }

      if (mobileTagCheckboxes.length > 0) {
        mobileTagCheckboxes.forEach((checkbox) => {
          const tagValue = checkbox.value?.trim();
          if (tagValue) {
            const existingTags = allParams["filter.p.tag"] || [];
            if (!existingTags.includes(tagValue)) {
              updateParam("filter.p.tag", tagValue, true);
            }
          }
        });
      }

      const sortByInput = document.getElementById("SortBy");
      const sortByValue = sortByInput ? sortByInput.value : null;
      if (sortByValue) {
        updateParam("sort_by", sortByValue);
      }

      const facetDrawer = document.getElementById("Facet-Drawer");
      if (facetDrawer) {
        const allDynamicCheckboxes = facetDrawer.querySelectorAll(
          'input[type="checkbox"][name^="filter."]:not([name*="price"]):not([name*="delivery"]):not([name*="certified"]):not([name*="filter.p.tag"])'
        );

        const dynamicFilterParams = new Set();
        allDynamicCheckboxes.forEach((checkbox) => {
          dynamicFilterParams.add(checkbox.name);
        });

        dynamicFilterParams.forEach((paramName) => {
          delete allParams[paramName];
          updatedParams.add(paramName);
        });

        const dynamicFilterCheckboxes = facetDrawer.querySelectorAll(
          'input[type="checkbox"][name^="filter."]:not([name*="price"]):not([name*="delivery"]):not([name*="certified"]):not([name*="filter.p.tag"]):checked'
        );

        const dynamicFiltersMap = new Map();

        dynamicFilterCheckboxes.forEach((checkbox) => {
          const paramName = checkbox.name;
          const paramValue = checkbox.value;

          if (paramName && paramValue) {
            if (!dynamicFiltersMap.has(paramName)) {
              dynamicFiltersMap.set(paramName, []);
            }
            dynamicFiltersMap.get(paramName).push(paramValue);
          }
        });

        dynamicFiltersMap.forEach((values, paramName) => {
          values.forEach((value) => {
            updateParam(paramName, value, true);
          });
        });
      }

      const searchParams = new URLSearchParams();

      if (existingSearchParam && existingSearchParam.trim() !== "") {
        searchParams.set("q", existingSearchParam.trim());
      }

      Object.entries(allParams).forEach(([key, value]) => {
        if (key === "q") return;

        if (Array.isArray(value)) {
          value.forEach((v) => searchParams.append(key, v));
        } else {
          searchParams.set(key, value);
        }
      });

      return searchParams;
    }

    _showLoadingState() {
      if (this.productGrid) {
        this.productGrid.classList.add("loading");

        if (!this.productGrid.querySelector(".loading-indicator")) {
          const loadingIndicator = document.createElement("div");
          loadingIndicator.className = "loading-indicator";
          loadingIndicator.innerHTML = `
            <div class="loading-spinner">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke-width="4" stroke-dasharray="30" stroke-linecap="round" />
              </svg>
            </div>
            <p>Loading...</p>
          `;
          loadingIndicator.style.cssText =
            "text-align: center; padding: 2rem 0; width: 100%;";

          if (!document.getElementById("loading-spinner-styles")) {
            const style = document.createElement("style");
            style.id = "loading-spinner-styles";
            style.textContent = `
              .loading-spinner svg {
                width: 40px;
                height: 40px;
                margin: 1rem auto;
                animation: rotate 1.5s linear infinite;
              }
              .loading-spinner circle {
                fill: none;
                stroke: currentColor;
                opacity: 0.5;
              }
              @keyframes rotate {
                100% { transform: rotate(360deg); }
              }
            `;
            document.head.appendChild(style);
          }

          this.productGrid.appendChild(loadingIndicator);
        }
      }

      if (this.productGridContainer) {
        this.productGridContainer.classList.add("loading");
      }
    }

    _hideLoadingState() {
      if (this.productGrid) {
        this.productGrid.classList.remove("loading");

        const loadingIndicator =
          this.productGrid.querySelector(".loading-indicator");
        if (loadingIndicator) {
          loadingIndicator.remove();
        }
      }

      if (this.productGridContainer) {
        this.productGridContainer.classList.remove("loading");
      }
    }

    _redirectToNewUrl(paramsString) {
      const newUrl = paramsString
        ? `${window.location.pathname}?${paramsString}`
        : window.location.pathname;

      history.pushState({ searchParams: paramsString }, "", newUrl);

      this.fetchFilteredResults(paramsString);
    }

    fetchFilteredResults(paramsString) {
      const params = new URLSearchParams(paramsString);
      const searchQuery = params.get("q")?.toLowerCase();

      const isSearchMode = params.has("q");
      const hasSearchContent = searchQuery && searchQuery.trim() !== "";

      const hasServerSideFilters =
        params.has("filter.v.price.gte") ||
        params.has("filter.v.price.lte") ||
        params.has("filter.p.m.wk_custom_field.cus_delivery_speed") ||
        params.has("delivery") ||
        params.has("filter.p.m.custom.certified") ||
        params.has("filter.p.tag") ||
        params.has("sort_by");

      if (
        isSearchMode &&
        hasSearchContent &&
        this.productGrid &&
        !hasServerSideFilters
      ) {
        const paginationElement = document.querySelector("pagination-theme");
        paginationElement?.style && (paginationElement.style.display = "none");

        this._fetchAndFilterProducts(params, searchQuery);
        return;
      }

      if (isSearchMode && hasSearchContent && hasServerSideFilters) {
        const paginationElement = document.querySelector("pagination-theme");
        paginationElement?.style && (paginationElement.style.display = "none");

        this._fetchServerSideResultsThenClientSearch(paramsString, searchQuery);
        return;
      }

      this._showLoadingState();

      const currentParams = new URLSearchParams(window.location.search);
      const fetchParams = new URLSearchParams(paramsString);
      
      if (hasServerSideFilters && currentParams.has("page") && currentParams.get("page") !== "1") {
        fetchParams.delete("page");
        const newUrl = fetchParams.toString() 
          ? `${window.location.pathname}?${fetchParams.toString()}`
          : window.location.pathname;
        history.replaceState({ searchParams: fetchParams.toString() }, "", newUrl);
      }

      const url = `${window.location.pathname}?section_id=${this.productGrid.dataset.id}&${fetchParams.toString()}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          return response.text();
        })
        .then((html) => {
          this._updateProductGridFromHTML(html);
          this._hideLoadingState();

          this._updateProductCount();
        })
        .catch((error) => {
          console.error("[FilterUpdater] Error updating products:", error);
          this._hideLoadingState();
          window.location.href = `${window.location.pathname}?${fetchParams.toString()}`;
        });
    }

    _updateProductGridFromHTML(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newProductGrid = doc.getElementById("product-grid");
      const currentProductGrid = document.getElementById("product-grid");

      if (newProductGrid && currentProductGrid) {
        currentProductGrid.innerHTML = newProductGrid.innerHTML;

        if (newProductGrid.dataset.totalCount) {
          currentProductGrid.dataset.totalCount = newProductGrid.dataset.totalCount;
        }
      } else if (newProductGrid && this.productGridContainer) {
        const newProductGridContainer = doc.getElementById(
          "ProductGridContainer"
        );
        if (newProductGridContainer) {
          this.productGridContainer.innerHTML =
            newProductGridContainer.innerHTML;
          
          this.productGrid = document.getElementById("product-grid");
        }
      }

      const newProductCountLabel = doc.getElementById("ProductCountLabel");
      const currentProductCountLabel = document.getElementById("ProductCountLabel");
      
      if (newProductCountLabel && currentProductCountLabel) {
        currentProductCountLabel.textContent = newProductCountLabel.textContent;
      }

      const newPagination = doc.querySelector("pagination-theme");
      const currentPagination = document.querySelector("pagination-theme");
      
      if (newPagination && currentPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
        
        Array.from(newPagination.attributes).forEach(attr => {
          currentPagination.setAttribute(attr.name, attr.value);
        });
        
        currentPagination.style.display = "";
        currentPagination.removeAttribute("hidden");
        
      } else if (!newPagination && currentPagination) {
        currentPagination.style.display = "none";
      }

      const currentParams = new URLSearchParams(window.location.search);
      const hasClientSideSearch = currentParams.has("q") && currentParams.get("q").trim() !== "";
      
      if (hasClientSideSearch) {
        setTimeout(() => this._updateProductCount(), 50);
      }

      document.dispatchEvent(
        new CustomEvent("filterUpdater:productsUpdated", {
          detail: { container: this.productGridContainer },
        })
      );
    }

    _fetchAndFilterProducts(params, searchQuery) {
      this._showLoadingState();

      let allProducts = [];
      const batchSize = 250;
      let currentPage = 1;
      const maxPages = 20;

      const fetchParams = new URLSearchParams();
      const fetchPage = (page) => {
        fetchParams.set("page", page.toString());
        fetchParams.set("limit", batchSize.toString());

        const url = `${window.location.pathname}?section_id=${
          this.productGrid.dataset.id
        }&${fetchParams.toString()}`;

        return fetch(url)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Error HTTP: ${response.status}`);
            }
            return response.text();
          })
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const productGrid = doc.getElementById("product-grid");
            if (productGrid) {
              const productItems = productGrid.querySelectorAll("li.column");

              if (productItems && productItems.length > 0) {
                allProducts = allProducts.concat(Array.from(productItems));
              }

              if (productItems.length === batchSize && page < maxPages) {
                return fetchPage(page + 1);
              }
            }

            return allProducts;
          });
      };

      fetchPage(currentPage)
        .then((products) => {
          this._displayFilteredProducts(products, searchQuery);
        })
        .catch((error) => {
          console.error("[FilterUpdater] Error al buscar productos:", error);
          this._hideLoadingState();

          if (this.productGrid) {
            const errorMessage = document.createElement("div");
            errorMessage.className = "collection-empty collection-empty-error";
            errorMessage.innerHTML = `
              <p>Hubo un error al realizar la búsqueda. Por favor, intenta de nuevo.</p>
            `;

            this.productGrid.innerHTML = "";
            this.productGrid.appendChild(errorMessage);
          }
        });
    }

    _displayFilteredProducts(products, searchQuery) {
      if (!products || products.length === 0) {
        this._hideLoadingState();
        return;
      }

      this.productGrid.innerHTML = "";

      const tempContainer = document.createElement("div");

      products.forEach((product) => {
        tempContainer.appendChild(product.cloneNode(true));
      });

      this.productGrid.innerHTML = tempContainer.innerHTML;

      const productItems = this.productGrid.querySelectorAll("li.column");
      if (productItems && productItems.length > 0) {
        this._filterProductsInClient(productItems, searchQuery);
      }

      this._hideLoadingState();

      setTimeout(() => this._updatePaginationVisibility(), 100);

      setTimeout(() => this._updateProductCount(), 50);
    }

    _filterProductsInClient(productItems, searchQuery) {
      let foundMatches = false;
      let visibleCount = 0;

      if (!searchQuery || searchQuery.trim() === "") {
        productItems.forEach((item) => {
          item.style.display = "";
          visibleCount++;
        });

        const searchMessages = this.productGrid.querySelectorAll(
          ".collection-empty-search, .search-results-count"
        );
        searchMessages.forEach((msg) => msg.remove());

        return true;
      }

      productItems.forEach((item) => {
        const productTitle =
          item
            .querySelector(
              ".product-card-title, .card__heading, .product-item-meta__title"
            )
            ?.textContent.toLowerCase() || "";

        const productVendor =
          item
            .querySelector(".product-card-vendor")
            ?.textContent.toLowerCase() || "";

        const productSubtitle =
          item
            .querySelector(".product-card-subtitle")
            ?.textContent.toLowerCase() || "";

        const productDescription =
          item
            .querySelector(".product-description")
            ?.textContent.toLowerCase() || "";

        const allTextContent = Array.from(item.querySelectorAll("*"))
          .map((el) => el.textContent?.toLowerCase() || "")
          .join(" ");

        const matchFound =
          productTitle.includes(searchQuery) ||
          productVendor.includes(searchQuery) ||
          productSubtitle.includes(searchQuery) ||
          productDescription.includes(searchQuery) ||
          allTextContent.includes(searchQuery);

        if (matchFound) {
          item.style.display = "";
          foundMatches = true;
          visibleCount++;
        } else {
          item.style.display = "none";
        }
      });

      const emptyMessage = this.productGrid.querySelector(".collection--empty");
      if (emptyMessage) {
        if (visibleCount === 0) {
          emptyMessage.style.display = "block";

          if (!this.productGrid.querySelector(".collection-empty-search")) {
            const noResultsMessage = document.createElement("div");
            noResultsMessage.className =
              "collection-empty collection-empty-search";
            noResultsMessage.innerHTML = `
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
                <line x1="19.4142" y1="19" x2="17" y2="16.5858" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <p>No se encontraron productos que coincidan con "${searchQuery}".<br>Intenta con otro término de búsqueda.</p>
            `;

            const existingMessage = this.productGrid.querySelector(
              ".collection-empty-search"
            );
            if (existingMessage) {
              existingMessage.remove();
            }

            this.productGrid.appendChild(noResultsMessage);
          }
        } else {
          emptyMessage.style.display = "none";

          const noResultsMessage = this.productGrid.querySelector(
            ".collection-empty-search"
          );
          if (noResultsMessage) {
            noResultsMessage.remove();
          }

          if (
            searchQuery &&
            !this.productGrid.querySelector(".search-results-count")
          ) {
            const resultsCountMessage = document.createElement("div");
            resultsCountMessage.className = "search-results-count";
            resultsCountMessage.innerHTML = `<p>Se encontraron ${visibleCount} resultados para "${searchQuery}" en toda la colección</p>`;
            resultsCountMessage.style.cssText =
              "margin-bottom: 20px; font-size: 0.9em; color: #666;";

            this.productGrid.insertBefore(
              resultsCountMessage,
              this.productGrid.firstChild
            );
          } else if (this.productGrid.querySelector(".search-results-count")) {
            const resultsCountMessage = this.productGrid.querySelector(
              ".search-results-count"
            );
            resultsCountMessage.innerHTML = `<p>Se encontraron ${visibleCount} resultados para "${searchQuery}" en toda la colección</p>`;
          }
        }
      }

      setTimeout(() => this._updatePaginationVisibility(), 50);

      setTimeout(() => this._updateProductCount(), 50);

      return foundMatches;
    }

    _initializeSearchSystem() {
      if (!this.productGrid) {
        this.productGrid = document.getElementById("product-grid");
        if (!this.productGrid) {
          return false;
        }
      }

      if (!this.productGridContainer) {
        this.productGridContainer = document.getElementById(
          "ProductGridContainer"
        );
        if (!this.productGridContainer) {
          return false;
        }
      }

      return true;
    }

    _fetchServerSideResultsThenClientSearch(paramsString, searchQuery) {
      this._showLoadingState();

      const serverParams = new URLSearchParams(paramsString);
      serverParams.delete("q");
      const serverParamsString = serverParams.toString();

      const url = `${window.location.pathname}?section_id=${this.productGrid.dataset.id}&${serverParamsString}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          return response.text();
        })
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newProductGrid = doc.getElementById("product-grid");

          if (newProductGrid && this.productGrid) {
            this.productGrid.innerHTML = newProductGrid.innerHTML;

            const productItems = this.productGrid.querySelectorAll("li.column");
            if (productItems && productItems.length > 0) {
              if (searchQuery && searchQuery.trim() !== "") {
                this._filterProductsInClient(productItems, searchQuery);
              } else {
                productItems.forEach((item) => {
                  item.style.display = "";
                });

                const searchMessages = this.productGrid.querySelectorAll(
                  ".collection-empty-search, .search-results-count"
                );
                searchMessages.forEach((msg) => msg.remove());
              }
            }
          }

          this._hideLoadingState();

          setTimeout(() => {
            this._updatePaginationVisibility();
            this._updateProductCount();
          }, 100);
        })
        .catch((error) => {
          console.error("[FilterUpdater] Error en modo híbrido:", error);
          this._hideLoadingState();
          window.location.href = `${window.location.pathname}?${paramsString}`;
        });
    }

    _shouldShowPagination() {
      const productItems = this.productGrid?.querySelectorAll("li.column");
      if (!productItems) return false;

      const productsPerPageFromConfig = this._getProductsPerPageSetting();
      
      let visibleCount = 0;
      productItems.forEach((item) => {
        const isVisible = item.style.display !== "none";
        if (isVisible) {
          visibleCount++;
        }
      });

      const paginationElement = document.querySelector("pagination-theme");
      const hasPaginationLinks = paginationElement?.querySelector(".page-numbers, .load-more");
      
      return hasPaginationLinks && visibleCount >= productsPerPageFromConfig;
    }

    _getProductsPerPageSetting() {
      const productGrid = document.getElementById("product-grid");
      
      const commonSettings = [47, 30, 24, 12];
      
      const paginationLinks = document.querySelectorAll("pagination-theme a[href*='page=']");
      if (paginationLinks.length > 0) {
        return Math.min(...commonSettings);
      }

      return 47;
    }

    _updatePaginationVisibility() {
      const paginationElement = document.querySelector("pagination-theme");
      if (paginationElement) {
        const shouldShow = this._shouldShowPagination();
        paginationElement.style.display = shouldShow ? "" : "none";
      }
    }

    _ensurePaginationIsVisible() {
      const paginationElement = document.querySelector("pagination-theme");
      if (!paginationElement) return;

      const currentParams = new URLSearchParams(window.location.search);
      const hasServerSideFilters = 
        currentParams.has("filter.v.price.gte") ||
        currentParams.has("filter.v.price.lte") ||
        currentParams.has("filter.p.m.wk_custom_field.cus_delivery_speed") ||
        currentParams.has("delivery") ||
        currentParams.has("filter.p.m.custom.certified") ||
        currentParams.has("filter.p.tag") ||
        currentParams.has("sort_by");

      const paginationLinks = paginationElement.querySelectorAll("a[href*='page='], .page-numbers a, .pagination-item a");
      const loadMoreButton = paginationElement.querySelector(".load-more, .btn-load-more");
      const hasPaginationContent = paginationLinks.length > 0 || loadMoreButton;

      if ((hasServerSideFilters || hasPaginationContent) && paginationElement.style.display === "none") {
        paginationElement.style.display = "";
        paginationElement.removeAttribute("hidden");
        paginationElement.offsetHeight;
      }
    }

    _updateProductCount() {
      const productCountLabel = document.getElementById("ProductCountLabel");
      if (!productCountLabel) return;

      const currentParams = new URLSearchParams(window.location.search);
      const hasClientSideSearch = currentParams.has("q") && currentParams.get("q").trim() !== "";

      if (!hasClientSideSearch) {
        return;
      }

      const productItems = this.productGrid?.querySelectorAll("li.column");
      if (!productItems) {
        productCountLabel.textContent = "0 of 0 products";
        return;
      }

      let visibleCount = 0;
      productItems.forEach((item) => {
        const isVisible = item.style.display !== "none";
        if (isVisible) {
          visibleCount++;
        }
      });

      const totalCount = this.productGrid?.dataset.totalCount;

      if (totalCount) {
        productCountLabel.textContent = `${visibleCount} of ${totalCount} products`;
      } else {
        productCountLabel.textContent = `${visibleCount} products`;
      }
    }

    _detectFilterChanges(formData, currentParams) {
      const currentPriceGte = currentParams.get("filter.v.price.gte");
      const currentPriceLte = currentParams.get("filter.v.price.lte");
      const newPriceGte = formData.get("filter.v.price.gte");
      const newPriceLte = formData.get("filter.v.price.lte");

      if (currentPriceGte !== newPriceGte || currentPriceLte !== newPriceLte) {
        return true;
      }

      const currentDelivery = currentParams.get("filter.p.m.wk_custom_field.cus_delivery_speed");
      const newDelivery = formData.get("filter.p.m.wk_custom_field.cus_delivery_speed");

      if (currentDelivery !== newDelivery) {
        return true;
      }

      const currentCertified = currentParams.get("filter.p.m.custom.certified");
      const videoCertifiedToggle = document.getElementById("video-certified-toggle");
      const newCertified = videoCertifiedToggle?.checked ? "View all" : "";

      if (currentCertified !== newCertified) {
        return true;
      }

      const currentTags = currentParams.getAll("filter.p.tag");
      const activeTagButtons = document.querySelectorAll(".collection-tags__tag.collection-tags__tag--active");
      const newTags = Array.from(activeTagButtons).map(button => button.textContent?.trim()).filter(Boolean);

      if (currentTags.length !== newTags.length || !currentTags.every(tag => newTags.includes(tag))) {
        return true;
      }

      const currentSort = currentParams.get("sort_by");
      const sortByInput = document.getElementById("SortBy");
      const newSort = sortByInput?.value;

      if (currentSort !== newSort) {
        return true;
      }

      return false;
    }
  }

  let globalFilterUpdater = null;
  let isPaginationActive = false;

  function setupPaginationProtection() {
    document.addEventListener(
      "click",
      (event) => {
        const paginationLink =
          event.target.closest("a[href*='page=']") ||
          event.target.closest("pagination-theme a") ||
          event.target.closest(".pagination a");

        if (paginationLink) {
          isPaginationActive = true;

          setTimeout(() => {
            isPaginationActive = false;
          }, 2000);
        }
      },
      true
    );

    window.addEventListener("popstate", () => {
      const currentParams = new URLSearchParams(window.location.search);
      if (currentParams.has("page")) {
        isPaginationActive = true;

        setTimeout(() => {
          isPaginationActive = false;
        }, 1000);
      }
    });
  }

  async function applyFiltersGlobal(isFilterChange = true) {
    if (isPaginationActive) {
      return;
    }

    if (!isFilterChange && isOnlyPageNavigation()) {
      return;
    }

    const isMobileActive = document
      .querySelector("#Facet-Drawer")
      ?.classList.contains("active");
    if (
      isMobileActive &&
      typeof window.syncMobileInputsBeforeApply === "function"
    ) {
      window.syncMobileInputsBeforeApply();
    }

    if (!globalFilterUpdater) {
      globalFilterUpdater = new FilterUpdater();
    }

    await globalFilterUpdater.apply(isFilterChange);

    const priceSliderComponent = document.querySelector("custom-price-slider");
    if (priceSliderComponent && priceSliderComponent.isResetting) {
      priceSliderComponent.clearResettingFlag();
    }
  }

  function isOnlyPageNavigation() {
    const currentParams = new URLSearchParams(window.location.search);

    if (!currentParams.has("page")) {
      return false;
    }
    const paramsWithoutPage = new URLSearchParams();
    currentParams.forEach((value, key) => {
      if (key !== "page") {
        paramsWithoutPage.set(key, value);
      }
    });

    if (paramsWithoutPage.toString() === "") {
      return true;
    }

    return false;
  }

  window.applyFiltersGlobal = applyFiltersGlobal;

  function initializeUnifiedFilterSystem() {
    if (typeof window.applyFiltersGlobal !== "function") {
      window.applyFiltersGlobal = applyFiltersGlobal;
    }

    setupPaginationProtection();

    if (!globalFilterUpdater) {
      globalFilterUpdater = new FilterUpdater();
    }

    document.addEventListener("filtersUpdated", (event) => {
      // Event handler for filter updates
    });

    setTimeout(() => {
      if (
        globalFilterUpdater &&
        typeof globalFilterUpdater._updateProductCount === "function"
      ) {
        globalFilterUpdater._updateProductCount();
      }
    }, 500);

    if (typeof window.FilterUIManager !== "undefined") {
      const originalApply = window.FilterUIManager.updateAllDisplays;
      if (originalApply) {
        window.FilterUIManager.updateAllDisplays = function (params) {
          originalApply.call(this, params);
          if (globalFilterUpdater) {
            globalFilterUpdater.updateAllDisplays?.call(
              globalFilterUpdater,
              params
            );
          }
        };
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeUnifiedFilterSystem
    );
  } else {
    initializeUnifiedFilterSystem();
  }

  function getRenderedProductData() {
    const productGrid = document.getElementById("product-grid");
    if (!productGrid) {
      return [];
    }

    const productElements = productGrid.querySelectorAll("li.column");
    const productsData = [];

    productElements.forEach((productElement) => {
      const productInfo = {};

      const titleElement = productElement.querySelector(
        ".card__heading, .product-card__title, .product-item-meta__title"
      );
      if (titleElement) {
        productInfo.title = titleElement.textContent.trim();
      }

      const priceElement = productElement.querySelector(
        ".price, .price-item, .product-card-price"
      );
      if (priceElement) {
        productInfo.price = priceElement.textContent.trim();
      }

      if (Object.keys(productInfo).length > 0) {
        productsData.push(productInfo);
      }
    });

    return productsData;
  }

  function logProductDataRealTime() {
    const productGridContainer = document.getElementById(
      "ProductGridContainer"
    );

    if (!productGridContainer) {
      return;
    }

    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList" || mutation.type === "subtree") {
          const renderedProducts = getRenderedProductData();
          break;
        }
      }
    });

    observer.observe(productGridContainer, { childList: true, subtree: true });

    const initialProducts = getRenderedProductData();
  }

  logProductDataRealTime();
});
